var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.box]},[_c('img',{class:[_vm.$style.logo],attrs:{"src":require("@/assets/icon.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }